import React from "react";
import { Box, Divider, Slide, Stack, Typography } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import { Images } from "../../assets/common";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import { getErrorString } from "./../../constants/function";
import Notification from "../../components/Notification";
import NoData from "./../../components/Nodata";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { startStream } from "../../action/stream";
import { useTranslation } from "react-i18next";
import { useTheme as useAppTheme } from "../../context/ThemeContext";
export default function Notifications({
  onClick,
  notificationShow,
  unreadCnt,
  setUnreadCnt,
  openChat,
}) {
  const { t } = useTranslation("common");
  const { currentTheme } = useAppTheme();
  const palette = currentTheme?.palette || {};
  const custom = currentTheme?.custom || {};
  const paperColor = palette.background?.paper || "var(--paper-color, #171515)";
  const primaryColor = palette.primary?.main || "var(--primary-color, #FFEE20)";
  const textPrimary = palette.text?.primary || "var(--text-primary, #FFFFFF)";
  const dividerColor = palette.divider || `${primaryColor}33`;
  const toastShadow =
    palette.mode === "light"
      ? "0 18px 40px rgba(0, 0, 0, 0.18)"
      : "0 18px 40px rgba(0, 0, 0, 0.45)";
  const { isStream } = useSelector((state) => state.stream);
  const dispatch = useDispatch();
  const history = useHistory();
  const [notifications, setNotifications] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageNo, setPageNo] = React.useState(1);
  const [loaded, setLoaded] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const getNotifications = async (pageNo) => {
    try {
      setLoading(true);
      const response = await ApiService.NOTIFICATIONS(
        `?pageNo=${pageNo}&pageSize=15`
      );
      setNotifications([...notifications, ...response["result"]]);
      setLoaded(response["result"].length < 15 ? true : false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  const markAllRead = async (pageNo) => {
    try {
      setLoading(true);
      const payload = {
        status: "seen",
      };
      const response = await ApiService.MARK_ALL_SEEN(payload);
      if (response["code"] === 200) {
        for (var i = 0; i < notifications.length; i++) {
          notifications[i].status = "seen";
        }
        notificationShow(false);
        setUnreadCnt(0);
      } else {
        notifier.error(getErrorString(response["message"]));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };

  React.useEffect(() => {
    getNotifications(pageNo);
  }, []);
  const redirect = (path, id, seen) => {
    if (path) {
      if (unreadCnt === 1) setUnreadCnt(0);
      onClick(path, id, seen);
    }
  };
  const handleScroll = async (target) => {
    var a = target.scrollTop;
    var b = target.scrollHeight - target.clientHeight;

    if ((a / b) * 100 > 80 && !loading && !loaded) {
      // run a function called doSomething
      const next = pageNo + 1;
      setPageNo(next);
      getNotifications(next);
    }
  };
  const handleChatOpen = (e) => {
    openChat(e);
    notificationShow(false);
  };
  const getPlaylistDetail = async (channelName) => {
    if (!isStream) {
      try {
        setLoading(true);
        setMessage(t("loader.message14"));
        const response = await ApiService.PLAYLIST_DETAIL({
          _id: channelName,
          pageNo: 1,
          pageSize: 1,
        });
        if (!response?.result?.live) {
          setLoading(false);
          setMessage(null);
          notifier.error(t("notifier.error.toast3"));
          notificationShow(false);
          return;
        }
        if (
          response?.result?.live &&
          !response?.result?.isSubscribed &&
          response?.result?.private
        ) {
          setLoading(false);
          setMessage(null);
          notifier.error(t("notifier.error.toast4"));
          notificationShow(false);
          return;
        }
        const status = await getBlockedUserOfPlaylist(channelName);
        if (typeof status === "boolean" && status) {
          notifier.error(t("notifier.error.toast2"));
          notificationShow(false);
          return;
        }
        dispatch(
          startStream({
            streamData: response?.result,
            title: null,
            goal: null,
            goalDescription: null,
          })
        );
        setLoading(false);
        setMessage(null);
        notificationShow(false);
      } catch (error) {
        if (
          getErrorString(error) ===
          "This is an explicit content you need to be above 18 to view it"
        ) {
          notifier.error(getErrorString(error));
        }
        setLoading(false);
        setMessage(null);
        notificationShow(false);
      }
    } else notifier.warning("You have already joined a live stream");
  };
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      return response?.result?.isBlocked;
    } catch (error) {
      return null;
    }
  };
  return (
    <Box
      onScroll={(e) => handleScroll(e.target)}
      sx={{
        width: "423px",
        minHeight: "399px",
        maxHeight: "399px",
        position: "absolute",
        top: "65px",
        right: "0",
        zIndex: 999999999, // Ensure notifications are on top
        backgroundColor: paperColor,
        color: textPrimary,
        borderRadius: "16px",
        border: `1px solid ${custom.accent?.main || primaryColor}`,
        boxShadow: toastShadow,
        backdropFilter: "blur(18px)",
        overflow: "scroll",
      }}
    >
      <Box>
        <Stack
          direction="row"
          alignItems="flex-end"
          justifyContent="space-between"
          position="sticky"
          top="0"
          sx={{
            backgroundColor: paperColor,
            zIndex: 1,
          }}
        >
          <Typography
            className="fs-14"
            sx={{ padding: "12px 16px 9px", color: textPrimary, fontWeight: 600 }}
          >
            {t("notifications.header")}
          </Typography>
          <Typography
            className="fs-14"
            sx={{
              padding: "12px 16px 9px",
              color: primaryColor,
              fontWeight: 600,
            }}
            onClick={() => markAllRead()}
            style={{ cursor: "pointer" }}
          >
            {t("notifications.button")}
          </Typography>
        </Stack>
        <Divider
          orientation="horizontal"
          sx={{
            borderColor: dividerColor,
            backgroundColor: dividerColor,
          }}
        />
        <Box sx={{ padding: "16px" }}>
          <Stack spacing={1}>
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <Notification
                  key={index}
                  notification={notification}
                  onclick={(path, id, seen) => redirect(path, id, seen)}
                  openChat={(e) => handleChatOpen(e)}
                  getPlaylistDetail={getPlaylistDetail}
                />
              ))
            ) : (
              <NoData lable={t("noData.noData")} />
            )}
          </Stack>
        </Box>
      </Box>
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={message ? message : null}
        />
      ) : null}
    </Box>
  );
}
